import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Moon } from "lucide-react";
import { api, formatPrice, imgUrl } from "@/lib/api";
import { Reveal, SectionTitle } from "@/components/site/Primitives";

const WORDS = ["Kahvaltı", "Ev Yemekleri", "Çorba", "Kokoreç", "Premium Izgara", "Kafe", "Lezzet 7/24"];

export function Marquee() {
  const row = [...WORDS, ...WORDS];
  return (
    <div className="bg-[#D4AF37] text-[#140D0B] overflow-hidden py-4 border-y border-[#9E7B27]" data-testid="marquee-strip">
      <div className="marquee flex w-max gap-10 whitespace-nowrap">
        {[...row, ...row].map((w, i) => (
          <span key={i} className="font-display text-sm sm:text-base tracking-[0.3em] uppercase flex items-center gap-10">
            {w} <span className="h-1.5 w-1.5 rotate-45 bg-[#140D0B]" />
          </span>
        ))}
      </div>
    </div>
  );
}

export function Signature() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/menu").then(({ data }) => setItems(data.items.filter((i) => i.featured && i.available).slice(0, 5)));
  }, []);
  if (!items.length) return null;
  const [first, ...rest] = items;
  return (
    <section className="ym-dark py-24 sm:py-32" data-testid="signature-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-8">
          <Reveal><SectionTitle eyebrow="İmza Tabaklar" title={<>Ustanın <span className="gold-text italic">favorileri</span></>} /></Reveal>
          <Link to="/menu" className="btn-ghost-gold self-start md:self-auto" data-testid="signature-full-menu-btn">Tüm menü <ArrowRight size={16} /></Link>
        </div>
        <div className="mt-14 grid gap-5 md:grid-cols-4 md:grid-rows-2">
          <Reveal className="md:col-span-2 md:row-span-2">
            <DishCard item={first} big />
          </Reveal>
          {rest.map((it, i) => (
            <Reveal key={it.id} delay={0.08 * (i + 1)}>
              <DishCard item={it} />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}

const DishCard = ({ item, big }) => (
  <Link to="/menu" className={`img-zoom group relative block overflow-hidden rounded-lg border border-[#D4AF37]/20 ${big ? "h-[420px] md:h-full min-h-[420px]" : "h-[260px]"}`} data-testid={`signature-dish-${item.id}`}>
    <img src={imgUrl(item.image) || "/images/hero.jpg"} alt={item.name} className="absolute inset-0 h-full w-full object-cover" />
    <div className="absolute inset-0 bg-gradient-to-t from-[#140D0B] via-[#140D0B]/30 to-transparent" />
    <div className="absolute inset-x-0 bottom-0 p-6">
      {item.tags?.[0] && <span className="inline-block mb-3 rounded-full bg-[#C84B31] px-3 py-1 text-[10px] tracking-widest uppercase">{item.tags[0]}</span>}
      <div className="flex items-end justify-between gap-4">
        <h3 className={`font-serif-ym font-semibold leading-tight ${big ? "text-3xl sm:text-4xl" : "text-2xl"}`}>{item.name}</h3>
        <span className="font-display text-[#D4AF37] whitespace-nowrap">{formatPrice(item.price)}</span>
      </div>
      {big && <p className="mt-3 text-sm text-[#CBBBAE] max-w-md">{item.description}</p>}
    </div>
  </Link>
);

export function NightBanner() {
  return (
    <section className="relative overflow-hidden bg-[#2A1C18] text-[#FDFBF7]" data-testid="night-banner-section">
      <div className="grid lg:grid-cols-2">
        <div className="relative h-80 lg:h-auto img-zoom overflow-hidden">
          <img src="/images/soup2.jpg" alt="Gece çorbası" className="absolute inset-0 h-full w-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-r from-transparent to-[#2A1C18] hidden lg:block" />
        </div>
        <div className="px-5 sm:px-12 lg:px-16 py-20 lg:py-28">
          <Reveal>
            <div className="inline-grid place-items-center h-12 w-12 rounded-full border border-[#D4AF37]/50 text-[#D4AF37]"><Moon size={20} /></div>
            <p className="eyebrow mt-6">Gece Kuşlarına</p>
            <h2 className="mt-4 font-serif-ym text-4xl sm:text-5xl font-semibold leading-[1.05]">
              Saat kaç olursa olsun,<br />kazanımız hep kaynıyor.
            </h2>
            <p className="mt-6 text-[#CBBBAE] leading-relaxed max-w-lg">
              İşkembe, kelle paça, mercimek ve odun ateşinde kokoreç. Gece mesaisinden çıkanlara, maç sonrası
              acıkanlara, sabaha karşı sıcak bir tas arayanlara: Yeni Mercan 7/24 açık.
            </p>
            <div className="mt-10 grid grid-cols-3 gap-4 max-w-md">
              {[["07:00", "Kahvaltı"], ["12:00", "Ev Yemekleri"], ["03:00", "Çorba & Kokoreç"]].map(([t, l]) => (
                <div key={t} className="border-l border-[#D4AF37]/40 pl-4">
                  <p className="font-display text-2xl text-[#D4AF37]">{t}</p>
                  <p className="text-xs text-[#CBBBAE] mt-1">{l}</p>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
